import React from "react";
import featureScanner from "../assets/images/feature-scanner.png";
import featureBarcode from "../assets/images/feature-barcode.png";
import featureCoach from "../assets/images/feature-coach.png";
import featureTrack from "../assets/images/feature-track.png";

const features = [
  {
    title: "AI Food Scanner & Calorie Counter",
    description:
      "Snap a photo of any meal and get an instant calorie estimate. Our AI identifies foods and shows calories, protein, carbs, and fat in seconds.",
    imgSrc: featureScanner,
  },
  {
    title: "Barcode Scanner",
    description:
      "Scan barcodes on packaged foods for accurate, real-time calorie and macro data — perfect for groceries, snacks, and supplements.",
    imgSrc: featureBarcode,
  },
  {
    title: "Track Calories, Macros & Water",
    description:
      "Monitor daily calories with visual progress rings, track protein, carbs and fat, and stay hydrated with water tracking.",
    imgSrc: featureTrack,
  },
  {
    title: "Personal AI Nutrition Coach",
    description:
      "Ask questions about calories, nutrition, and macros, and get personalized guidance for weight loss, muscle building, and your goals.",
    imgSrc: featureCoach,
  },
];

const Features = () => {
  return (
    <div className="px-8 lg:px-32 xl:px-52">
      <h2 className="text-center text-2xl lg:text-3xl font-bold mb-5 mt-14">
        App Features
      </h2>
      <div className="container mx-auto px-5 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:grid-cols-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 border hover:shadow-[#12AD63]  transition-shadow duration-300"
            >
              <div className="flex justify-center mb-6">
                <div className="w-24 h-24 rounded-2xl bg-[#eafaf1] flex items-center justify-center">
                  <img
                    src={feature.imgSrc}
                    alt={feature.title}
                    className="w-16 h-16 object-contain"
                  />
                </div>
              </div>
              <h3 className="text-[20px] font-semibold text-center mb-4 text-[#0d0d0d]">
                {feature.title}
              </h3>
              <p
                className="text-[#222222] text-center text-[14px]"
                dangerouslySetInnerHTML={{ __html: feature.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
